enum IpexMomentEnum {
	giveMe = 'give_me',
	whatIsMe = 'what_is_me',
	showMe = 'show_me',
	makeItMe = 'make_it_me',
	helpMe = 'help_me',
	nonInteraction = 'non_interaction'
}

export default IpexMomentEnum;
